import React from 'react'
import Navigator from './Component/Navigation/Navigations'
function App() {
  return (
    <div>
      <Navigator />
    </div>
  )
}

export default App